module.exports = __webpack_public_path__ + "../resources/img/qr-ios-pro.7f05c4a4.png";